import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostZeitUnterartCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostZeitUnterartCommandService],
  exports: []
})
export class PostZeitUnterartCommandServiceModule { }
